import React, { useEffect } from "react";
// 引入 AOS 動畫庫與樣式檔，用於在頁面中實現進場動效
import Aos from "aos";
import "aos/dist/aos.css";
// 引入此元件對應的 CSS 樣式
import "./signature.css";
// 引入 React Router 的 Link，用於頁面跳轉
import { Link } from "react-router-dom";

// 引入圖示
import { HiOutlineLocationMarker } from "react-icons/hi";

// 引入圖片資源
import img3 from "../../Assets/signImg/img3.jpeg";

/*
  Data 陣列：
  - 儲存此行程頁面的主要資訊，如圖片、標題、地點、費用、描述等。
  - 若需擴充更多行程，只需在此陣列中加入對應物件即可。
*/
const Data = [
  {
    id: 3,
    imgSrc: img3,
    destTitle: "穩 扎 穩 打 - 德 國 職 業 教 育 移 民 考 察",
    location: "🇩🇪 · 德國",
    grade: "高中、職校、大學",
    fees: "6900 歐元",
    description:
      "德國是世界上最具性價比的留學目的地；也是最穩健職業道路的移民國家；從上學就有工資的職業教育，到全程免除學費的高等教育。全程體驗從不同檔次的留學，到職場，到生活的德國社會。更有全方位留學和移民指導。",
  },
];

/*
  Signature3 元件：
  - 使用 AOS 進行頁面動畫初始化。
  - 透過 Data 陣列動態渲染行程資訊，並展示費用、參團訊息與行程表等內容。
  - 提供「返回主頁」按鈕供使用者導覽。
*/
export default function Signature3() {
  // 在元件掛載時初始化 AOS，設定動畫持續時間為 2000 毫秒
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="signMain signContainer signSection">
      {/* 頁面標題區域 */}
      <div className="signSecTitle">
        <h3 data-aos="fade-right" className="signTitle">
          穩 扎 穩 打 - 德 國 職 業 移 民 考 察
        </h3>
        <button className="signHomeBtn">
          <Link to={"/"} className="signHomeBtnLink">
            返 回 主 頁
          </Link>
        </button>
      </div>

      {/* 主要內容區：使用 Grid 佈局 */}
      <div className="signSecContent signGrid">
        {Data.map(
          ({ id, imgSrc, destTitle, location, company, fees, description }) => {
            return (
              <div key={id} data-aos="fade-up" className="signSingleDestination">
                {/* 左側文字資訊區塊 */}
                <div className="signCardInfo">
                  <h4 className="signDestTitle">{destTitle}</h4>
                  <span className="signContinent signFlex">
                    <HiOutlineLocationMarker className="icon" />
                    <span className="signName">{location}</span>
                  </span>

                  {/* 行程特色與詳細描述 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        執行機構：{company}
                        <br />
                        <br />
                        <small>⭐️ 行 程 特 色</small>
                        <br />
                        <br />
                      </span>
                    </div>
                    <div>
                      <p>{description}</p>
                      <table width="70%">
                        <thead>
                          <tr>
                            <th width="20%"></th>
                            <th width="10%"></th>
                            <th width="70%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>活動內容</td>
                            <td></td>
                            <td>
                              雙元制教育考察，職業培訓考察，高等教育考察，就業環境考察，社區生活考察
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>後續服務</td>
                            <td></td>
                            <td>
                              從零基礎德語學習，到專業選擇，入學高等職業學校，到畢業就業，全程服務。（另行付費）
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>德國優勢</td>
                            <td></td>
                            <td>
                              從受教育到就業，穩步前進，前景可期；德國教育和德國身分被全世界認可，
                              <b>德國身分回中國免簽證</b>；德國社會穩定，就業需求旺盛，保障健全，生活品質高
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>未來規劃</td>
                            <td></td>
                            <td>
                              職業教育實習期間有工資發放。畢業後可選擇就讀高等院校（全免費），也可選擇就業。無論藍領、白領，德國工資水準在全歐洲領先。
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>專案流程</td>
                            <td></td>
                            <td>
                              <b>❤️ 專案啟動即可赴德國；</b>
                              <br />
                              <b>❤️ 零基礎開始學習德語；</b>
                              <br />
                              <b>❤️ 1年後開始專業技能學習；</b>
                              <br />
                              <b>❤️ 2-3年後開始帶薪實習；</b>
                              <br />
                              <b>❤️ 3-4年後入職全職工作；</b>
                              <br />
                              <b>❤️ 4-5年後開始移民申請；</b>
                              <br />
                              <b>❤️ 7-8年後申請入籍；</b>
                              <br />
                            </td>
                          </tr>
                          <br />
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* 參團資訊區塊 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 參 團 信 息</small>
                      </span>
                      <br />
                      <br />
                    </div>{" "}
                    <br />
                    <table width="80%">
                      <thead>
                        <tr>
                          <th width="20%"></th>
                          <th width="10%"></th>
                          <th width="70%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>適合人群</td>
                          <td></td>
                          <td>16-30 歲高中生；職校學生；大專院校、高等院校學生；有初級工作經驗的年輕人</td>
                        </tr>
                        <br />
                        <tr>
                          <td>時 間</td>
                          <td></td>
                          <td>全年</td>
                        </tr>
                        <br />
                        <tr>
                          <td>時 長</td>
                          <td></td>
                          <td>9 天</td>
                        </tr>
                        <br />
                        <tr>
                          <td>地 點</td>
                          <td></td>
                          <td>德國 · 薩克森州州府 · 德累斯頓</td>
                        </tr>
                        <br />
                        <tr>
                          <td>費 用 包 括</td>
                          <td></td>
                          <td>
                            邀請函簽發，輔助辦理簽證；在德期間學校、企業的考察諮詢；飲食、交通、課程、資料等費用（住宿費用需自理）；
                            <br />
                            本次考察費用可
                            <b style={{ color: "red" }}>全款抵扣</b>
                            後期的語言學習、入學、入職、移民申請等全程職業移民服務費用。
                          </td>
                          <br />
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 德國薪資水準表格 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 德 國 薪 資 水 準 （2022年 IAMEXPAT 統計）</small>
                      </span>
                      <br />
                      <br />
                    </div>{" "}
                    <br />
                    <table width="80%">
                      <thead>
                        <tr>
                          <th width="30%">全德國全職職員</th>
                          <th width="70%">月薪中位數</th>
                        </tr>
                        <br />
                      </thead>
                      <tbody>
                        <tr>
                          <td>具有博士學歷的職員</td>
                          <td>8687 歐元（67758 元人民幣）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>具有碩士學歷的職員</td>
                          <td>6188 歐元（48266 元人民幣）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>
                            <b style={{ color: "red" }}>
                              具有職業技術技能教育的職員
                            </b>
                          </td>
                          <td>
                            <b style={{ color: "red" }}>4826 歐元</b>
                            （37642 元人民幣）
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <td>具有本科學歷的職員</td>
                          <td>4551 歐元（35497 元人民幣）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>所有工種</td>
                          <td>4100 歐元（31980 元人民幣）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>
                            <b style={{ color: "green" }}>
                              透過職業技術短期培訓的職員
                            </b>
                          </td>
                          <td>
                            <b style={{ color: "green" }}>3521 歐元</b>
                            （27463 元人民幣）
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <td>沒有任何工作技能</td>
                          <td>2817 歐元（22100 元人民幣）</td>
                        </tr>
                        <br />
                      </tbody>
                    </table>
                  </div>

                  {/* 德國日常開銷表格 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 德 國 日 常 開 銷 （2022年 非超大城市）</small>
                      </span>
                      <br />
                      <br />
                    </div>{" "}
                    <br />
                    <table width="80%">
                      <thead>
                        <tr>
                          <th width="20%">物品 / 需求</th>
                          <th width="35%">單 身 貴 族</th>
                          <th width="45%">四 口 之 家</th>
                        </tr>
                        <br />
                      </thead>
                      <tbody>
                        <tr>
                          <td>租房</td>
                          <td>460 歐元 / 月 / 一間臥室（3588 元人民幣）</td>
                          <td>1100 歐元 / 月 / 3 間臥室（8580 元人民幣）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>買房</td>
                          <td>3500 歐元 / 平方米（27300 元人民幣 / 平米）</td>
                          <td>3500 歐元 / 平方米（27300 元人民幣 / 平米）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>公共交通</td>
                          <td>49 歐元 / 成人全德國月票（2022年）</td>
                          <td>49 歐元 / 成人全德國月票（2022年）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>私家車</td>
                          <td>23180 歐元 / 新款大眾高爾夫（180800 人民幣）</td>
                          <td>42000 歐元 / 新款寶馬五系（327600 人民幣）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>醫療保險</td>
                          <td>300 歐元 / 月 醫療全部免費</td>
                          <td>600 歐元 / 月 醫療全部免費</td>
                        </tr>
                        <br />
                        <tr>
                          <td>日常飲食</td>
                          <td>300 歐元 / 月</td>
                          <td>600 歐元 / 月</td>
                        </tr>
                        <br />
                        <tr>
                          <td>衣物 + 日用品</td>
                          <td>200 歐元 / 月</td>
                          <td>500 歐元 / 月</td>
                        </tr>
                        <br />
                        <tr>
                          <td>教育</td>
                          <td>全免費（從幼兒園到博士後）</td>
                          <td>全免費（從幼兒園到博士後）</td>
                        </tr>
                        <br />
                        <tr>
                          <td>育兒</td>
                          <td></td>
                          <td>政府補貼給家庭每位 18 歲以下兒童 250-420 歐元 / 月</td>
                        </tr>
                        <br />
                        <tr>
                          <td>休假</td>
                          <td>每年 4-6 週全薪休假 / 6 週全薪病假</td>
                          <td>每年 4-6 週全薪休假 / 6 週全薪病假 / 14 週全薪產假</td>
                        </tr>
                        <br />
                      </tbody>
                    </table>
                  </div>

                  {/* 參考行程區塊 */}
                  <div className="signFees">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 參 考 行 程</small>
                      </span>
                      <br />
                      <br />
                    </div>
                    <br />
                    <p>實際活動內容會有前後調整；或被相近內容替代：</p>
                    <br />
                    <table width="70%">
                      <thead>
                        <tr>
                          <th width="20%">日期</th>
                          <th width="40%">上午</th>
                          <th width="40%">下午</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>週六</td>
                          <td>出發</td>
                          <td>抵達德國</td>
                        </tr>
                        <tr>
                          <td>週日</td>
                          <td>遊覽德累斯頓</td>
                          <td>歡迎晚餐</td>
                        </tr>
                        <tr>
                          <td>週一</td>
                          <td>考察雙元制職業教育</td>
                          <td>考察德語學校：試聽 0 基礎德語課</td>
                        </tr>
                        <tr>
                          <td>週二</td>
                          <td>考察應用技術型大學</td>
                          <td>考察職業學院培訓基地</td>
                        </tr>
                        <tr>
                          <td>週三</td>
                          <td>考察市政府市民服務等相關部門</td>
                          <td>德國社會、生活、文化講座和答疑</td>
                        </tr>
                        <tr>
                          <td>週四</td>
                          <td>考察汽車行業公司</td>
                          <td>考察醫療 / 護理行業公司</td>
                        </tr>
                        <tr>
                          <td>週五</td>
                          <td>考察機械行業公司</td>
                          <td>考察食品行業公司</td>
                        </tr>
                        <tr>
                          <td>週六</td>
                          <td>考察當地市民日常購物、娛樂、休閒、出行</td>
                          <td>居住等生活環境和模式</td>
                        </tr>
                        <tr>
                          <td>週日</td>
                          <td>返程</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 預售價格與預報名按鈕 */}
                  <div className="signPrice">
                    <h5>預 售 價 格 ：{fees}</h5>
                  </div>
                  <Link to={"/formReg"} target="_blank">                  
                  <button className="signBtn signFees">
                    <h4>⭐️ ⭐️ ⭐️ 預 約 報 名 - 搶 先 卡 位 ⭐️ ⭐️ ⭐️</h4>
                  </button>
                  </Link>
                </div>

                {/* 右側圖片區塊 */}
                <div className="signImageDiv">
                  <img src={imgSrc} alt={destTitle} />
                </div>
              </div>
            );
          }
        )}
      </div>
    </section>
  );
}